<template>
  <div class="app-container">
    <div class="filter-container">
      <el-radio-group v-model="listQuery.package_type" class="filter-item" @change="handleFilter">
        <el-radio-button :label="1">普通优惠券</el-radio-button>
        <el-radio-button :label="2">充值优惠券</el-radio-button>
      </el-radio-group>
    </div>

    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-select v-model="listQuery.shop_id" placeholder="请选择店铺" class="filter-item" filterable clearable>
        <el-option v-for="item in shops" :key="item.id" :label="item.shop_name" :value="item.id"></el-option>
      </el-select>

      <el-select v-show="listQuery.package_type === 2" v-model="listQuery.coupon_product_id" placeholder="请选择优惠券包" class="filter-item" filterable clearable>
        <el-option v-for="item in couponProductList" :key="item.id" :label="`${item.name}（￥${item.discount_total}---${item.num_total}张）`" :value="item.id"></el-option>
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>
    </div>

    <div v-loading="listLoading" style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.platformDiscountMoney || 0 }}</div>
            <div class="subtitle">全平台优惠券额度</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.singleShopDiscountMoney || 0 }}</div>
            <div class="subtitle">指定店铺优惠券额度</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.multiShopDiscountMoney || 0 }}</div>
            <div class="subtitle">指定多店铺优惠券额度</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="店铺名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.shop.shop_name }}
        </template>
      </el-table-column>

      <el-table-column label="支付用户" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.user.avatar" class="user-avatar">
            <span>{{ scope.row.user.name }}</span>
            <span>{{ scope.row.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="实付金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_money }}
        </template>
      </el-table-column>

      <el-table-column label="优惠券优惠范围" min-width="110" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.user_coupon.coupon.coupon_scope === 1">【全平台】</div>
          <div v-else-if="scope.row.user_coupon.coupon.coupon_scope === 2">
            <div>【指定店铺】</div>
            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ scope.row.user_coupon.coupon.shop.shop_name }}</div>
          </div>
          <div v-else-if="scope.row.user_coupon.coupon.coupon_scope === 3">
            <div>【指定多店铺】</div>
            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" :title="scope.row.user_coupon.coupon.shop_names">{{ scope.row.user_coupon.coupon.shop_names }}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="优惠券优惠金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_coupon_discount_money }}
        </template>
      </el-table-column>

      <el-table-column label="配送方式" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.send_type === 1">配送服务</span>
          <span v-else-if="scope.row.send_type === 2">智慧餐柜</span>
          <span v-else-if="scope.row.send_type === 3">自取服务</span>
          <span v-else-if="scope.row.send_type === 4">堂食服务</span>
        </template>
      </el-table-column>

      <el-table-column label="支付方式" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.pay_type === 1">微信</el-tag>
          <el-tag type="primary" v-else-if="scope.row.pay_type === 2">余额</el-tag>
          <el-tag type="warning" v-else-if="scope.row.pay_type === 3">积分</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_type === 4">数字人民币</el-tag>
          <el-tag type="success" v-else-if="scope.row.pay_type === 5">易票联微信</el-tag>
          <el-tag type="success" v-else-if="scope.row.pay_type === 6">富友微信</el-tag>
          <el-tag type="warning" v-else-if="scope.row.pay_type === 7">教师卡</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.pay_status === 0">未支付</el-tag>
          <el-tag type="success" v-else-if="scope.row.pay_status === 1">已支付</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_status === 2">已退款</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.order_status === 0">未接单</el-tag>
          <el-tag type="info" v-else-if="scope.row.order_status === 1">已接单</el-tag>
          <el-tag type="info" v-else-if="scope.row.order_status === 2">待评价</el-tag>
          <el-tag type="success" v-else-if="scope.row.order_status === 3">已完成</el-tag>
          <el-tag type="danger" v-else-if="scope.row.order_status === 4">已取消</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="发货状态" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- 兼容商城发货 -->
          <el-tag type="warning" v-if="scope.row.order_type === 2 && scope.row.shipping_status === 1">配送中</el-tag>
          <el-tag type="info" v-else-if="scope.row.order_type === 2 && scope.row.shipment_status === 0">待发货</el-tag>
          <el-tag type="info" v-else-if="scope.row.order_type === 2 && scope.row.shipment_status === 1">待收货</el-tag>
          <el-tag type="success" v-else-if="scope.row.order_type === 2 && scope.row.shipment_status === 2">已收货</el-tag>
          <el-tag type="info" v-else-if="scope.row.shipping_status === 0 && scope.row.send_type === 3">待出餐</el-tag>
          <el-tag type="info" v-else-if="scope.row.shipping_status === 0 && scope.row.send_type === 4">待堂食</el-tag>
          <el-tag type="info" v-else-if="scope.row.shipping_status === 0">未配送</el-tag>
          <el-tag type="warning" v-else-if="scope.row.shipping_status === 1 && scope.row.send_type === 3">待自提</el-tag>
          <el-tag type="warning" v-else-if="scope.row.shipping_status === 1">配送中</el-tag>
          <el-tag type="success" v-else-if="scope.row.shipping_status === 2 && scope.row.send_type === 3">已自提</el-tag>
          <el-tag type="success" v-else-if="scope.row.shipping_status === 2 && scope.row.send_type === 4">已堂食</el-tag>
          <el-tag type="success" v-else-if="scope.row.shipping_status === 2">已送达</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="下单时间" min-width="160" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  var moment = require("moment");

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          package_type: 1,
          school_id: "",
          shop_id: "",
          coupon_product_id: "",
          start_date: "",
          end_date: "",
        },
        dateArr: null,
        platformDiscountMoney: null,
        singleShopDiscountMoney: null,
        multiShopDiscountMoney: null,
        shops: null,
        // 优惠券包列表
        couponProductList: null,
      };
    },
    created() {
      this.listQuery.start_date = moment().format("YYYY-MM-DD");
      this.listQuery.end_date = moment().format("YYYY-MM-DD");
      this.dateArr = [this.listQuery.start_date, this.listQuery.end_date];
      this.getList();
      this.getShopList();
      this.getCouponProductList();
    },
    computed: {
      ...mapGetters(["schools", "school_id", "user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
        this.getShopList();
        this.getCouponProductList();
      },
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_date = newVal[0];
          this.listQuery.end_date = newVal[1];
        } else {
          this.listQuery.start_date = "";
          this.listQuery.end_date = "";
        }
      }
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/coupon/useCount",
          method: "get",
          params: this.listQuery,
          timeout: 6000000,
        }).then((response) => {
          this.list = response.data.items;
          this.total = response.data.total;
          this.platformDiscountMoney = response.data.platformDiscountMoney;
          this.singleShopDiscountMoney = response.data.singleShopDiscountMoney;
          this.multiShopDiscountMoney = response.data.multiShopDiscountMoney;
          this.listLoading = false;
        });
      },
      getShopList() {
        request({
          url: "/api/backend/shop/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            school_id: this.school_id
          }
        }).then(response => {
          this.shops = response.data.data;
        });
      },
      getCouponProductList() {
        request({
          url: "/api/backend/couponProduct/list",
          method: "get",
          params: {
            page: 1,
            limit: 100000,
            school_id: this.school_id,
          }
        }).then(response => {
          this.couponProductList = response.data.data;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
    },
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    text-align: center;
    .value {
      color: #546DFE;
      font-weight: bold;
      font-size: 26px;
    }
    .subtitle {
      font-size: 12px;
      color: gray;
      margin-top: 6px;
    }
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
